import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

export interface MaintenanceDialogData {
  titleKey: string;
  messageKey: string;
  storageKey: string;
}

@Component({
  selector: 'app-maintenance-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    TranslateModule,
  ],
  templateUrl: './maintenance-dialog.component.html',
  styleUrls: ['./maintenance-dialog.component.scss']
})
export class MaintenanceDialogComponent implements OnInit {
  public title: string = '';
  public message: string = '';

  constructor(
    public dialogRef: MatDialogRef<MaintenanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MaintenanceDialogData,
    @Inject(PLATFORM_ID) private platformId: Object,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.translateService.get(this.data.titleKey).subscribe((translation: string) => {
      this.title = translation;
    });

    this.translateService.get(this.data.messageKey).subscribe((translation: string) => {
      this.message = translation;
    });
  }

  onClose(): void {
    if (isPlatformBrowser(this.platformId) && this.data.storageKey) {
      localStorage.setItem(this.data.storageKey, 'true');
    }
    this.dialogRef.close();
  }
}
